import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Explorerpanindiacabservicefrompune() {



const cardData = {
  keyword: "Explorer Pan India Cab Service from Pune",
  heading: "Lotus Cab: Explorer Pan India Cab Service from Pune",

  headingDescription:
    "Lotus Cab proudly offers Explorer Pan India Cab Service from Pune, connecting you to destinations across India with comfort, safety, and reliability. Whether you need a one-way drop to another state, a round-trip interstate journey, corporate travel across major cities, or a family road trip to tourist destinations, we provide flexible long-distance taxi solutions. Our fleet includes AC sedans, spacious SUVs, luxury vehicles, Innova Crysta, Urbania vans, and mini buses for group travel. All vehicles are driven by professional, highway-experienced chauffeurs who ensure safe interstate travel. With transparent per kilometer pricing, customizable itineraries, and 24/7 booking support, Lotus Cab makes long-distance Pan India travel convenient and stress-free.",

  top: "Popular Pan India Routes from Pune with Lotus Cab",

  topPlaces: [
    {
      title: "Pune to Mumbai",
      description:
        "Mumbai is one of the most frequently booked Pan India routes from Pune. Ideal for business meetings, airport transfers, and leisure travel, this route offers smooth expressway connectivity. AC sedans and SUVs ensure comfortable travel. Lotus Cab provides both one-way and round-trip packages."
    },
    {
      title: "Pune to Hyderabad",
      description:
        "Hyderabad is a major IT and corporate hub. Many travelers book long-distance interstate taxis for business travel and relocation. Spacious SUVs are ideal for this 600+ km journey."
    },
    {
      title: "Pune to Bangalore",
      description:
        "Bangalore is a key corporate and tech destination. Corporate clients often book chauffeur-driven cabs for interstate travel. Flexible multi-day travel packages available."
    },
    {
      title: "Pune to Goa",
      description:
        "Goa is a popular family and weekend trip destination. SUV and luxury cab bookings are common for group and leisure travel."
    },
    {
      title: "Pune to Delhi",
      description:
        "Long-distance interstate taxi bookings to Delhi are ideal for corporate delegations and relocation journeys."
    },
    {
      title: "Pune to Ahmedabad",
      description:
        "Ahmedabad route connects Maharashtra and Gujarat for business and family travel."
    },
    {
      title: "Pune to Chennai",
      description:
        "Chennai travel often requires professional long-distance chauffeurs for smooth interstate journeys."
    },
    {
      title: "Pune to Jaipur",
      description:
        "Jaipur is a popular tourist and wedding destination. Luxury cab options are ideal for premium travel."
    }
  ],

  services: [
    {
      name: "Pan India Cab Service from Pune",
      description:
        "Lotus Cab offers comprehensive Pan India cab services from Pune covering all major cities across India. Suitable for business travel, family vacations, relocation journeys, and corporate delegations. Transparent per kilometer pricing with customizable itineraries. AC sedans, SUVs, luxury vehicles, and mini buses available."
    },
    {
      name: "One Way Cab Pune to Any City",
      description:
        "Affordable one-way interstate cab service where customers pay only for single-side distance. Ideal for relocation and airport transfers."
    },
    {
      name: "Round Trip Cab Pune to Other Cities",
      description:
        "Flexible round-trip taxi packages with multi-day booking options for comfortable interstate travel."
    },
    {
      name: "Corporate Cab Pan India Pune",
      description:
        "Professional corporate travel solutions for intercity meetings, conferences, and employee transportation."
    },
    {
      name: "Family Trip Cab Pan India from Pune",
      description:
        "Spacious SUV and luxury cab options for comfortable family road trips across India."
    },
    {
      name: "Mini Bus Pan India from Pune",
      description:
        "Group travel mini bus booking for weddings, religious tours, and corporate outings across states."
    },
    {
      name: "Luxury Cab Pan India Pune",
      description:
        "Premium luxury vehicles for executive and VIP interstate travel."
    },
    {
      name: "Online Cab Booking Pan India from Pune",
      description:
        "Instant online booking with transparent pricing and 24/7 customer support."
    }
  ],

  tableData: [
    ["Pan India Cab Service from Pune", "Pune to All India Cab Booking"],
    ["Outstation Cab Pune to Other Cities", "AC Cab Pune to India Destinations"],
    ["Sedan Cab Pan India from Pune", "SUV Cab Pan India Pune"],
    ["Luxury Cab Pan India Pune", "One Way Cab Pune to Any City"],
    ["Round Trip Cab Pune to Other Cities", "Family Trip Cab Pan India from Pune"],
    ["Corporate Cab Pan India Pune", "Mini Bus Pan India from Pune"],
    ["Airport Transfer Pan India from Pune", "Per Km Cab Pune to India Cities"],
    ["Online Cab Booking Pan India from Pune", "Chauffeur Driven Cab Pan India Pune"],
    ["Long Distance Cab Pune to India", "Best Cab Service Pan India from Pune"],
    ["Affordable Outstation Cab Pune", "Weekend Trip Cab Pan India from Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Nationwide Coverage",
      WhyChoosedescription:
        "Travel from Pune to any major city across India with reliable interstate taxi service."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear and competitive pricing model without hidden charges."
    },
    {
      WhyChooseheading: "Experienced Interstate Drivers",
      WhyChoosedescription:
        "Professional chauffeurs trained for long-distance highway driving."
    },
    {
      WhyChooseheading: "Wide Fleet Selection",
      WhyChoosedescription:
        "Choose from sedan, SUV, luxury cars, Urbania, and mini bus options."
    },
    {
      WhyChooseheading: "Corporate Travel Expertise",
      WhyChoosedescription:
        "Tailored transport solutions for companies and business travelers."
    },
    {
      WhyChooseheading: "Family & Group Friendly",
      WhyChoosedescription:
        "Spacious vehicles suitable for family vacations and group tours."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription:
        "One-way, round-trip, and multi-day interstate packages available."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock booking assistance and travel coordination."
    }
  ]
};

const faqData = [
  { question: "Can I book cab from Pune to any city in India?", answer: "Yes, Pan India interstate cab service is available from Pune." },
  { question: "Is one-way booking available?", answer: "Yes, affordable one-way interstate taxi options are available." },
  { question: "Are luxury vehicles available?", answer: "Yes, premium luxury cars are available for executive travel." },
  { question: "Is corporate booking supported?", answer: "Yes, corporate Pan India cab packages are available." },
  { question: "Is fare calculated per km?", answer: "Yes, transparent per kilometer pricing is followed." },
  { question: "Are vehicles AC?", answer: "Yes, all vehicles are air-conditioned." },
  { question: "Is online booking available?", answer: "Yes, instant online booking is available." },
  { question: "Are drivers experienced?", answer: "Yes, professional interstate chauffeurs ensure safe travel." },
  { question: "Is group travel possible?", answer: "Yes, mini bus and SUV options are available for group travel." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock assistance is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Sharma",
    feedback:
      "Booked Pune to Bangalore Pan India cab. Smooth interstate travel and professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Family trip to Goa from Pune was comfortable. Spacious SUV and transparent pricing.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable Pan India cab service for business travel across states. Highly recommended.",
    rating: 5
  }
];
























































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Explorer Pan India Cab Service from Pune",
  "image": "https://lotuscab.com/assets/images/pan-india-cab-service-pune.jpg", 
  "description": "Lotus Cab offers Pan India cab services from Pune, including one-way and round-trip travel to all major cities in India. Choose from AC, sedan, SUV, and luxury cabs, Mini Bus, and chauffeur-driven options. Ideal for family trips, corporate travel, airport transfers, long-distance journeys, and weekend getaways. Book online for affordable, safe, and comfortable travel across India.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/explorer-pan-india-cab-service-pune"
  }
};









  return (
    <div>
      


<Helmet>
  <title>Contact: +91 8767592195 | Explorer Pan India Cab Service from Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pan India cab services from Pune with Lotus Cab. One-way & round-trip to all major cities, AC, sedan, SUV & luxury cabs, Mini Bus, chauffeur-driven. Family, corporate, airport, long-distance & weekend trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pan India Cab Service from Pune, Pune to All India Cab Booking, Outstation Cab Pune to Other Cities, AC Cab Pune to India Destinations, Sedan Cab Pan India from Pune, SUV Cab Pan India Pune, Luxury Cab Pan India Pune, One Way Cab Pune to Any City, Round Trip Cab Pune to Other Cities, Family Trip Cab Pan India from Pune, Corporate Cab Pan India Pune, Mini Bus Pan India from Pune, Airport Transfer Pan India from Pune, Per Km Cab Pune to India Cities, Online Cab Booking Pan India from Pune, Chauffeur Driven Cab Pan India Pune, Long Distance Cab Pune to India, Best Cab Service Pan India from Pune, Affordable Outstation Cab Pune, Weekend Trip Cab Pan India from Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Explorerpanindiacabservicefrompune;